<template>
  <div class="layout-wrapper outer-layout">
    <div class="footer-push login-screen">
      <div class="public-bg"></div>
      <landing-navbar></landing-navbar>
      <router-view></router-view>
      <landing-footer></landing-footer>
    </div>
  </div>
</template>

<script>
import LandingNavbar from '@/components/common/LandingNavbar'
import LandingFooter from '@/components/common/LandingFooter'

export default {
  name: 'LandingLayout',
  components: {
    LandingNavbar,
    LandingFooter
  }
}
</script>

<style lang="scss">
  @import '@/scss/views/_login.scss';
</style>
